import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_PHARMACY_CATEGORIES } from "../../action-types/actions";

import i18n from "../../i18n";
export const getPharmacyCategories = createAsyncThunk(
  ACTIONS_GET_PHARMACY_CATEGORIES.get_pharmacy_categories,
  async ({ is_active, search } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const params = {};
      if (is_active !== undefined) {
        params.is_active = is_active;
      }
      if (search) {
        params.search = search;
      }

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyCategories}`,
        {
          params,
        },
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchPharmacyCategories"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingPharmacyCategories");

      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
